<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Your Payment Cards" />
    </template>
    <template v-if="loaded">
      <form @submit.prevent="submit">
        <template v-if="cards.length">
          <base-table>
            <thead>
              <tr>
                <th>Default</th>
                <th>Card Type</th>
                <th>Card Number</th>
                <th>Expiry</th>
                <th>Nickname</th>
                <th/>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(card, key) in cards" :key="key">
                <td class="text-center">
                  <base-radio
                    name="default"
                    native-value="true"
                    :value="isDefault(card._id)"
                    @input="changeDefault(card._id)">
                    Default
                  </base-radio>
                </td>
                <td>{{ card.type }}</td>
                <td>{{ card.mask }}</td>
                <td>{{ card.expiry }}</td>
                <td>
                  <base-field row>
                    <base-input placeholder="nickname" v-model="cards[key].nickname"/>
                  </base-field>
                </td>
                <td class="text-right">
                  <base-button danger icon-right="trash" :loading="removing.includes(card._id)" @click="remove(key)">
                    Delete
                  </base-button>
                </td>
              </tr>
            </tbody>
          </base-table>
        </template>
        <template v-else>
          <p>
            No cards have been added yet.
          </p>
        </template>
        <div class="mt-4 text-right">
          <base-button icon-right="arrow-right" :loading="saving" primary submit>
            Update Cards
          </base-button>
        </div>
      </form>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  async created () {
    await this.$store.dispatch('core/user-cards/list', {
      query: {
        user: this.$auth.user._id
      }
    })

    this.cards = this.$_.cloneDeep(this.userCards)
    this.cards.map(card => {
      if (card.default) this.default = card._id
    })
    this.loaded = true
  },

  data: () => ({
    cards: [],
    default: '',
    loaded: false,
    removing: [],
    saving: false
  }),

  components: {
    HeroHeader
  },

  computed: {
    ...mapState({
      userCards: store => store.core.userCards.rows
    })
  },

  methods: {
    changeDefault (id) {
      this.default = id
    },

    isDefault (id) {
      return this.default === id
    },

    async remove (index) {
      await this.$dialog.confirm('Are you sure you want to delete this card?', async () => {
        const card = this.cards[index]

        this.removing.push(card._id)

        await this.$store.dispatch('core/user-cards/remove', card)

        this.cards.splice(index, 1)

        this.$flash.success('Card successfully deleted.')
      })
    },

    async submit () {
      this.saving = true

      await Promise.all(this.cards.map(card => {
        card.default = this.default === card._id

        this.$store.dispatch('core/user-cards/save', card)
      }))

      this.$flash.success('Cards successfully updated.')

      this.saving = false
    }
  }
}
</script>
